import React from 'react';
import Iframe from 'react-iframe';

const ElementarySchoolPage = () => (
  <Iframe
    url='https://visualization.audit.samiksha.samagra.io/public/dashboard/77361c9f-155f-4829-9d16-aab02d5e7a12'
    width='100%'
    height='100%'
    display='initial'
    position='relative'
  />
);

export default ElementarySchoolPage;
